<template>
  <div class="navPage animate__animated animate__bounceInRight" :style="{height:screenHeight}">
      <div class="navPage1">
          <ul class="navTextGroup">
              <li @click="goToUrl('/')">
                  <span class="navTextTitle">首页</span>
                  <span class="navTextDesc">HOME</span>
              </li>
          </ul>
          <img src="https://qd365oss.oss-cn-beijing.aliyuncs.com/web/h5/close.png" style="width:20px;float:right;margin-right:20px;margin-top:20px;" @click="closeNavModal">
      </div>
      <div class="navPage2">
          <ul class="navTextGroup">
              <li @click="goToUrl('/join')">
                  <span class="navTextTitle">城市合作</span>
                  <span class="navTextDesc">JOIN US</span>
              </li>
          </ul>
      </div>
      <div class="navPage3">
          <ul class="navTextGroup">
              <li @click="goToUrl('/news')">
                  <span class="navTextTitle">365头条</span>
                  <span class="navTextDesc">365 NEWS</span>
              </li>
          </ul>
      </div>
      <div class="navPage4">
          <ul class="navTextGroup">
              <li @click="goToUrl('/brand')">
                  <span class="navTextTitle">品牌实力</span>
                  <span class="navTextDesc">BRAND</span>
              </li>
          </ul>
      </div>
      <div class="navPage5">
          <ul class="navTextGroup">
              <li @click="goToUrl('/riderHome')">
                  <span class="navTextTitle">骑士之家</span>
                  <span class="navTextDesc">RIDER</span>
              </li>
          </ul>
      </div>
  </div>
</template>

<script>
  export default {
    name: 'fourthPage',
    data(){
      return {
        screenHeight:0,
        screenWidth:0,
        activeIndex:0,
      }
    },
    props: {
      msg: String
    },
    mounted(){
    },
    created(){
      this.screenHeight = document.documentElement.clientHeight+'px';
      this.screenWidth = document.documentElement.clientWidth+'px';
    },
    methods:{
      // 翻页方法 子传父
      closeNavModal(){
        this.$emit('closeNavModal');
      },
        // 页面跳转
        goToUrl(url){
            this.$router.push(url);
        },
    }
  }
</script>
<style lang="less">
    .navPage1{height:20%;background: #404042;width:100%;float:left;margin-bottom:-1px;}
    .navPage2{height:20%;background: #323234;width:100%;float:left;margin-bottom:-1px;}
    .navPage3{height:20%;background: #222224;width:100%;float:left;margin-bottom:-1px;}
    .navPage4{height:20%;background: #171719;width:100%;float:left;margin-bottom:-1px;}
    .navPage5{height:20%;background: #000000;width:100%;float:left;margin-bottom:-1px;}
    .navTextGroup{float:left;width:70%;margin-top:9%;margin-left:15%;}
    .navTextTitle,.navTextDesc{width:100%;float:left;font-size:1.6em;line-height: 40px;}
    .navTextTitle{color:#fff;}
    .navTextDesc{color:#ccc;}
    .van-popup,.navPage{background: transparent !important;}
</style>
